import { useMemo, FunctionComponent } from 'react';
import { ModalWrapper } from './ModalWrapper';
import PreviewPageModal from 'components/Dialogs/PreviewPageModal/PreviewPageModal';
import RenameModal from 'components/Dialogs/RenameModal/RenameModal';
import SaveModal from 'components/Dialogs/SaveModal/SaveModal';
import PreviewPDFModal from 'components/Dialogs/PreviewPDFModal/PreviewPDFModal';
import { EntityId } from '@reduxjs/toolkit';
import RenameFileModal from './SaveModals/RenameFileModal/RenameFileModal';
import { ModalType } from './types';
import PreviewPageFromSaveModal from './SaveModals/PreviewPageModal/PreviewPageFromSaveModal';
import CloseAppModal from './CloseAppModal/CloseAppModal';

export interface ModalsProps {
    type: ModalType;
    actualPageId: EntityId;
    toggleModalOpen: (type: ModalType) => void;
    showRemoved?: boolean;
    toggleShowRemoved?: () => void;
}

export const Modals = (props: ModalsProps) => {
    const { type, toggleModalOpen, actualPageId, showRemoved, toggleShowRemoved } = props;
    const FormComponent = useMemo<FunctionComponent<ModalsProps> | undefined>(() => {
        switch (type) {
            case 'rename':
                return RenameModal;
            case 'renameFileFromSave':
                return RenameFileModal;
            case 'pagePreview':
                return PreviewPageModal;
            case 'pagePreviewFromSave':
                return PreviewPageFromSaveModal;
            case 'pdfPreview':
                return PreviewPDFModal;
            case 'save':
                return SaveModal;
            case 'close':
                return CloseAppModal;
            default:
                return undefined;
        }
    }, [type]);
    return (
        <ModalWrapper open={Boolean(type)} onClose={() => toggleModalOpen(null)}>
            {FormComponent && (
                <FormComponent
                    type={type}
                    toggleModalOpen={toggleModalOpen}
                    actualPageId={actualPageId}
                    showRemoved={showRemoved}
                    toggleShowRemoved={toggleShowRemoved}
                />
            )}
        </ModalWrapper>
    );
};
